import { RequestErrorInterface, RequestErrorResponseInterface } from '../types'

export default class RequestError extends Error implements RequestErrorInterface {
	constructor(message: string, public response: RequestErrorResponseInterface) {
		super(message)
	}
}
